import React from 'react'
import { ErrorHTTPStatusCodeProps } from './types'
import { ComplementText, DesText, ErrorImage, MainContainer } from './styles'
import Button from '../../Buttons/Button'

const ERROR_IMAGE_URL =
  'https://s3.amazonaws.com/yes.network/static-files/404-error.png'

function ErrorHTTPStatusCode({
  des,
  complement,
  actionButton,
  onActionButtonClick,
  actionButtonWrapper
}: ErrorHTTPStatusCodeProps) {
  const RenderButton = () => {
    if (!actionButton) {
      return null
    }

    if (actionButtonWrapper) {
      return actionButtonWrapper({
        children: <Button onClick={onActionButtonClick}>{actionButton}</Button>
      })
    }

    return <Button onClick={onActionButtonClick}>{actionButton}</Button>
  }

  return (
    <MainContainer>
      <ErrorImage src={ERROR_IMAGE_URL} />
      <DesText>{des}</DesText>
      <ComplementText>{complement}</ComplementText>
      {RenderButton()}
    </MainContainer>
  )
}

export default ErrorHTTPStatusCode
